import {UyapRequest} from "./UyapRequest";
import {AdresRow} from "./CommonInterfaces";

export interface MtsTebligatListTalep {
    dosyaId: number | string
}

export class MtsTebligatListCevap {
    items: MtsTebligatListRow[] = [];
    message: string = '';
}

export interface MtsTebligatListRow {
    dosyaNoYil: number,
    dosyaSiraNo: number,
    dosyaNo: string,
    dosyaTurKod: number,
    TebligatStatu: number,
    TebligatSonuc: string,
    TebligatTuru: number,
    tebligatTuruAciklamasi: string,
    TebligatTipi: string,
    TebligatTipiAciklamasi: string,
    TebligatYapilanKisininAdiSoyadi: string,
    TebligatAdresi: AdresRow,
    GGEvrakID: number,
    tebligatIlanBilgileri: Array<any>,
    KayitID: number,
    postayaVerildi: boolean,
    tebligatYapilanKisiTGNLKAYITKisiKurumID: number,
    dosyaID: string,
    tebligatKayitTablosuKayitTarihi: string,
    tebligatKayitTablosuKayitTarihiFormatted: string,
    mersule: string,
    dagitimID: number,
    secili: boolean,
    raporId: number,
    tarafList: Array<any>,
    vekilTarafList: Array<any>,
    tahsilatList: Array<any>,
    adliYardimTalebi: number,
    gonderiTipi: number,
    masrafGgIdList: Array<any>,
    donusluTebligat: number,
    icraDairesiMi: boolean,
    idariYargiMi: boolean,
    hukukMu: boolean,
    vekilliktenAzledilenlereMi: boolean,
    onaySonrasiIcraMi: boolean,
    kaydedildi: boolean,
    // Sorgulamada ekleniyor
    sonSafahatBilgisi?: any,
    sonSafahatMessage?: string
}

export class MtsTebligatList extends UyapRequest<MtsTebligatListTalep, MtsTebligatListCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    getMockResponse(): any {
        return [{"dosyaNoYil":2025,"dosyaSiraNo":1110011,"dosyaNo":"2025/1110011","dosyaTurKod":294,"TebligatStatu":9,"TebligatTuru":0,"tebligatTuruAciklamasi":"Kapalı Tebligat","TebligatTipi":"TBLTP00001","TebligatTipiAciklamasi":"Normal Tebligat","TebligatYapilanKisininAdiSoyadi":"BORÇLU VE MÜFLİS TEST SANAYİ TİCARET LİMİTED ŞİRKETİ","TebligatAdresi":{"ilKodu":7,"ilAdi":"ANTALYA","ilceAdi":"KEPEZ","ilceKodu":18,"adres":"TEST MAHALLESİ TEST SK. NO: 0/ KEPEZ/ANTALYA","kisiKurumID":18911111,"adresID":234401110,"adresTuru":"ADRTR00011","eklenebilirAdresMi":false,"kayitliAdresMi":false,"aktifAdresmi":false,"guncellendiMi":false},"GGEvrakID":16360111111,"TebligatSonuc":"PTT Sonuç Dönmedi","tebligatIlanBilgileri":[],"KayitID":15965111111,"postayaVerildi":false,"tebligatYapilanKisiTGNLKAYITKisiKurumID":1891111111,"dosyaID":"cSISPWMGYu6T8LaPI35OKLUXjlouIKfS4@Unaq0Xy@xxxxxxxx+xxxxxx+","tebligatKayitTablosuKayitTarihi":"Nov 18, 2025 2:36:42 PM","tebligatKayitTablosuKayitTarihiFormatted":"18/11/2025 14:36","mersule":"4100125111111","dagitimID":3390111111,"secili":false,"raporId":1636111111,"tarafList":[],"vekilTarafList":[],"tahsilatList":[],"adliYardimTalebi":1,"gonderiTipi":0,"masrafGgIdList":[],"donusluTebligat":0,"icraDairesiMi":false,"idariYargiMi":false,"hukukMu":false,"vekilliktenAzledilenlereMi":false,"onaySonrasiIcraMi":false,"kaydedildi":false}];
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'mts_tebligat_list_brd.ajx';
    }

    async parse(data: any): Promise<MtsTebligatListCevap> {
        if(data){
            return {
                items: data,
                message: ''
            }
        }else{
            throw new Error("Tebligat listesi bulunamadı");
        }

    }

}

export default MtsTebligatList;
